/**
 * API Configuration file
 * This file centralizes API URL configuration to ensure consistency across the application
 */

// Determine the base API URL based on environment
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

/**
 * Generate a full API endpoint URL
 * @param {string} endpoint - The API endpoint (without the base URL)
 * @returns {string} The complete API URL
 */
export const getApiUrl = (endpoint) => {
  // Ensure endpoint starts with a slash if it doesn't already
  const formattedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${formattedEndpoint}`;
};

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: getApiUrl('/api/auth/login'),
  ME: getApiUrl('/api/auth/me'),
  REGISTER: getApiUrl('/api/auth/register'),
};

// Cliente endpoints
export const CLIENTE_ENDPOINTS = {
  LOGIN: getApiUrl('/api/clientes/login'),
  ME: getApiUrl('/api/clientes/me'),
  REGISTER: getApiUrl('/api/clientes/register'),
};